import './styles.scss';

import { useAuth0 } from '@auth0/auth0-react';
import { faArrowRotateRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import IllustrationError from '../../assets/Illustration-error.svg';
import ImmersiveLogo from '../../assets/immersive-logo-dark.svg';
import UserMenu from '../../components/userMenu/user-menu';
import { darkTheme } from '../../theme/theme';
import Background from '../../widgets/immersive/background/background';

const NotPermission = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth0();

  const handleResetPage = () => {
    navigate('/');
  };

  useEffect(() => {
    if (!isLoading && !user) {
      navigate('/');
    }
  }, [isLoading, user]);

  return (
    <section className="not-permission-page">
      <ThemeProvider theme={darkTheme}>
        <Background />
        <CssBaseline />
        <div className="header-bar">
          <img src={ImmersiveLogo} alt="Immersive finance" />
          <UserMenu hasPermission={false} />
        </div>
        <div className="error-page-wrapper">
          <img src={IllustrationError} alt="error" />
          <div className="error-page-content">
            <h1>
              <p>Oops!</p>
            </h1>
            <p className="error-description">
              Something went wrong. Please, refresh the page or try again later.
            </p>

            <Button className="bt-refresh-page" onClick={handleResetPage}>
              <FontAwesomeIcon icon={faArrowRotateRight} />
              <span> Refresh page</span>
            </Button>
          </div>
        </div>
      </ThemeProvider>
    </section>
  );
};

export default NotPermission;
